import { Helmet } from "react-helmet-async"
import { Currencies } from "../../../../TenantProfile/Currencies"

export default function OrganizationCurrenciesSettingsPage() {
	return (
		<>
			<Helmet>
				<title>Currencies & Exchange Rates</title>
			</Helmet>
			<Currencies />
		</>
	)
}
